import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "ui/Button";
import { getGameTypeById, getHour } from "domain/Directories/selectors";
import { DateTime as Luxon } from "luxon";
import AnimatedModal from "components/Modal/AnimatedModal";
import PropTypes from "prop-types";

const PayStatusModals = ({ gameData }) => {
    const [isShow, setIsShow] = useState(true);
    const {
        pay_status,
        type_id,
        starts_at,
        organizer,
        is_training,
        trainer,
        unsubscribe_hours,
    } = gameData;

    const isPaySuccess =
        pay_status === "succeeded" || pay_status === "waiting_for_capture"
            ? true
            : false;
    const gameType = useSelector((state) => getGameTypeById(state, type_id));
    const startDT = Luxon.fromSQL(starts_at);

    const onClose = () => {
        setIsShow(false);
    };

    return (
        <>
            {isShow && (
                <>
                    {isPaySuccess ? (
                        <AnimatedModal
                            visible={true}
                            title={"Вы оплатили игру"}
                            onClose={onClose}
                            closeOnOverlay={true}
                            modificators={[`min-padding`]}
                        >
                            {(close) => (
                                <>
                                    <p className="text-center c-gs-medium-em mb-32">
                                        {gameType.name}.{" "}
                                        {startDT.toFormat("dd.LL.yyyy")} в{" "}
                                        {startDT.toLocaleString(
                                            Luxon.TIME_24_SIMPLE
                                        )}
                                        . Организатор -{" "}
                                        {`${organizer.family_name} ${organizer.name}`}
                                        {is_training &&
                                            trainer &&
                                            `, тренер - ${trainer.family_name} ${trainer.name}`}
                                    </p>
                                    <p className="text-center c-gs-medium-em mb-32">
                                        Напоминаем, что если вы не сможете
                                        принять участие в игре, то отписаться
                                        необходимо{" "}
                                        <span className="fs-body2">
                                            не позднее, чем за{" "}
                                            {unsubscribe_hours}{" "}
                                            {getHour(unsubscribe_hours)} до
                                            начала.
                                        </span>{" "}
                                        Оплата будет возвращена автоматически
                                    </p>
                                    <div className="btn-group-row">
                                        <Button
                                            primary
                                            size="medium"
                                            mixes={[`m-x-auto`]}
                                            onClick={close}
                                        >
                                            <span className="btn__span">
                                                Ок
                                            </span>
                                        </Button>
                                    </div>
                                </>
                            )}
                        </AnimatedModal>
                    ) : (
                        <AnimatedModal
                            visible={true}
                            title={"Во время оплаты произошла ошибка"}
                            onClose={onClose}
                            closeOnOverlay={true}
                            modificators={[`min-padding`]}
                        >
                            {(close) => (
                                <>
                                    <p className="text-center c-gs-medium-em mb-32">
                                        Приносим свои извинения за неудобства,
                                        попробуйте оплатить еще раз
                                    </p>
                                    <div className="btn-group-row">
                                        <Button
                                            primary
                                            size="medium"
                                            mixes={[`m-x-auto`]}
                                            onClick={close}
                                        >
                                            <span className="btn__span">
                                                Ок
                                            </span>
                                        </Button>
                                    </div>
                                </>
                            )}
                        </AnimatedModal>
                    )}
                </>
            )}
        </>
    );
};

PayStatusModals.propTypes = {
    gameData: PropTypes.object,
};

export default PayStatusModals;
